import type { AbsolutePath } from "shelving";
import { sumNumbers } from "shelving";
import { Grid, Icon, Page } from "shared/react";
import { type ContentEntity, type ContentType, REACTION_MAX } from "shared/schema";
import { formatCompactNumber } from "shared/util/number";
import { EntityBackgroundHeader } from "../entity/EntityBackgroundHeader.js";
import { EntityButton } from "../entity/EntityButton.js";
import { RewardIcon } from "../reward/RewardIcon.js";
import { useCreatedItem } from "../util/data.js";
import { useQuery } from "../util/db.js";

export function ReactionsPage({ type, id }: { type: ContentType; id: string }): React.ReactElement {
	const target: ContentEntity = `${type}:${id}`;
	const path: AbsolutePath = `/reactions/${type}/${id}`;
	const reactable = useCreatedItem(target);
	const reactions = reactable.data.reactions;
	const sum = sumNumbers(Object.values(reactions));
	return (
		<Page title="Reactions" path={path}>
			<EntityBackgroundHeader entity={target} mods="pad-3x">
				<div>
					<h1>Reactions</h1>
				</div>
				<EntityButton entity={target} mods="pin-bottom pin-left size-small" />
			</EntityBackgroundHeader>
			<Grid
				mods="grid-square grid-cols-4 gap-medium"
				store={useQuery("reaction", { target, $order: "!count", $limit: REACTION_MAX })}
				mapper={({ reaction, count }) => (
					<a key={reaction} href={`${path}/${reaction}`} className="icon">
						<RewardIcon id={reaction} type="reaction" /> <span className="badge pin-bottom pin-right">{formatCompactNumber(count)}</span>
					</a>
				)}
				after={
					<a href={`${path}/all`} className="icon color-gold">
						<Icon icon="reaction" /> <span className="badge pin-bottom pin-right">{formatCompactNumber(sum)}</span>
					</a>
				}
				empty="No reactions yet"
			/>
		</Page>
	);
}
